import styled from '@emotion/styled';
import { Theme } from '@emotion/react';
import { FollowUpStatus } from 'services/order/order.type';

export const BannerContainer = styled.div<{ style: ReturnType<typeof getStatusStyle> }>`
    background: ${({ style }) => style.background};
    border: ${({ style }) => style.border};
    border-radius: ${({ theme }) => theme.base.radius.lg};
    padding: 16px 24px;
    display: flex;
    align-items: center;
    margin: 16px;
    cursor: pointer;
`;

export const StatusText = styled.span<{ color: string }>`
    color: ${({ color }) => color};
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
`;

export const Spacer = styled.div`
    flex: 1;
`;

export const getStatusStyle = (status: FollowUpStatus, theme: Theme) => {
    switch (status) {
        case 'WAITING':
            return {
                background: theme.base.colors.destructive[50] || '#FFE5E5',
                color: theme.feature.errorColor,
                border: `1px solid ${theme.feature.errorColor}`,
                chevron: theme.feature.errorColor,
                icon: 'hourglass-line',
            };
        case 'PROCESSING':
            return {
                background: theme.base.colors.orange[50] || '#FFF7E0',
                color: theme.base.colors.warning[600],
                border: `1px solid ${theme.base.colors.warning[600]}`,
                chevron: theme.base.colors.warning[600],
                icon: 'box-3-line',
            };
        case 'READY':
            return {
                background: theme.base.colors.success[50] || '#E6F7E6',
                color: theme.feature.successColor,
                border: `1px solid ${theme.feature.successColor}`,
                chevron: theme.feature.successColor,
                icon: 'check-line',
            };
        case 'COLLECTED':
            return {
                background: theme.base.colors.neutral[100] || '#FDEEDC',
                color: theme.base.colors.neutral[600],
                border: `1px solid ${theme.base.colors.neutral[600]}`,
                chevron: theme.base.colors.neutral[600],
                icon: 'check-double-line',
            };
        case 'CANCELLED':
            return {
                background: theme.base.colors.neutral[100] || '#F0F0F0',
                color: theme.base.colors.neutral[500] || '#A0A0A0',
                border: `1px solid ${theme.base.colors.neutral[500]}`,
                chevron: theme.base.colors.neutral[500] || '#A0A0A0',
                icon: 'close-circle-line',
            };
        default:
            return {
                background: theme.base.colors.destructive[50] || '#FFE5E5',
                color: theme.feature.errorColor,
                border: `1px solid ${theme.feature.errorColor}`,
                chevron: theme.feature.errorColor,
                icon: 'cube-line',
            };
    }
};
